module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-vietnamese-400-normal.woff2?3230f9b040f3c630e0c34c9296b74778";